import "./i18n";

import { Route, Routes, Outlet } from "react-router-dom";
import { Suspense, lazy } from "react";

import  Loader  from "./components/Loader/Loader";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTopWindow from "./components/ScrollToTop/ScrollToTop";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from "react-i18next";
import { Categories } from './pages/admin/Categories';
import ProductsByCategory from './pages/admin/ProductsByCategory';

// import { useDispatch, useSelector } from "react-redux";
// import { useEffect, useState } from "react";

const Login = lazy(() => import("./pages/Login"));
const Home = lazy(() => import("./pages/Home"));
const NotFound = lazy(() => import("./pages/NotFound"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const RepresentativeDashboard = lazy(() => import("./pages/RepresentativeDashboard"));
const AccountantDashboard = lazy(() => import("./pages/AccountantDashboard"));
const Unauthorized = lazy(() => import("./pages/Unauthorized"));
const AdminClients = lazy(() => import("./pages/admin/Clients"));
const AdminProducts = lazy(() => import("./pages/admin/Products"));
const AdminInvoices = lazy(() => import("./pages/admin/Invoices"));
const AdminTransactions = lazy(() => import("./pages/admin/Transactions"));
const AdminReports = lazy(() => import("./pages/admin/Reports"));
const AdminMaps = lazy(() => import("./pages/admin/Maps"));
const AdminRoutes = lazy(() => import("./pages/admin/Routes"));
const AdminSettings = lazy(() => import("./pages/admin/Settings"));
const AdminRepresentatives = lazy(() => import("./pages/admin/Representatives"));
const RepresentativesStock = lazy(() => import("./pages/admin/RepresentativesStock"));
const RepresentativesRoutes = lazy(() => import("./pages/admin/RepresentativesRoutes"));
const RepresentativesClients = lazy(() => import("./pages/admin/RepresentativesClients"));
const RepInvoiceNew = lazy(() => import("./pages/rep/RepInvoiceNew"));
const RepInvoiceList = lazy(() => import("./pages/rep/RepInvoiceList"));
const RepClients = lazy(() => import("./pages/rep/RepClients"));
const RepRoutes = lazy(() => import("./pages/rep/RepRoutes"));
const AdminTrips = lazy(() => import("./pages/admin/Trips"));


function App() {
  const { i18n } = useTranslation();

  return (
    <div dir={i18n.language === "en" ? "ltr" : "rtl"}
    className={`w-full
  overflow-x-clip text-blue-2 ${i18n.language === "ar"
        ? "font-tajawal" : "font-goli"} font-tajawal`}>
    {/* <Nav /> */}
    <ScrollToTopWindow />
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/admin" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AdminDashboard />
            </ProtectedRoute>
        }>
          <Route index element={<div className="text-xl">Admin Dashboard Home</div>} />
          <Route path="clients" element={<AdminClients />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="products/categories" element={<Categories />} />
          <Route path="products/category/:categoryName" element={<ProductsByCategory />} />
          <Route path="invoices" element={<AdminInvoices />} />
          <Route path="transactions" element={<AdminTransactions />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="maps" element={<AdminMaps />} />
          <Route path="routes" element={<AdminRoutes />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="representatives" element={<AdminRepresentatives />} />
          <Route path="representatives/:id/stock" element={<RepresentativesStock />} />
          <Route path="representatives/:id/routes" element={<RepresentativesRoutes />} />
          <Route path="representatives/:id/clients" element={<RepresentativesClients />} />
          <Route path="trips" element={<AdminTrips />} />
        </Route>
        <Route path="/representative" element={<ProtectedRoute allowedRoles={["representative"]}><RepresentativeDashboard /></ProtectedRoute>}>
          <Route path="clients" element={<RepClients />} />
          <Route path="routes" element={<RepRoutes />} />
          <Route path="stock" element={<div>My Stock (TODO)</div>} />
          <Route path="maps" element={<div>My Maps (TODO)</div>} />
          <Route path="invoices" element={<Outlet />}>
            <Route index element={<RepInvoiceList />} />
            <Route path="new" element={<RepInvoiceNew />} />
          </Route>
        </Route>
        <Route path="/accountant" element={<ProtectedRoute allowedRoles={["accountant"]}><AccountantDashboard /></ProtectedRoute>} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
    <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={i18n.language === "ar"} pauseOnFocusLoss draggable pauseOnHover />
    {/* <Footer /> */}
  </div>
  );
}

export default App;
